<div class="modal fade" id="myMapModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Business Location</h5>
          <button type="button" (click)="closeMapModel()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="map-modal">
              <div class="row">
                <div class="col-sm-6">
                  <app-premium-ads-slider (click)="closeMapModel()"></app-premium-ads-slider>
                </div>
                <div class="col-sm-6">
                  <div id="singleMap">
                      <span id="mapLatitude" #mapLatitude></span> | <span id="mapLongitude" #mapLatitude></span>
                      <div>
                      <iframe width="100%" height="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.14615365208!2d72.71603444904773!3d19.082177211190135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1722571947497!5m2!1sen!2sin"
                                              style="border:0;" allowfullscreen="" loading="lazy"
                                              referrerpolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                  </div>

                </div>
              </div>
            </div>
        </div> 
        <div class="modal-footer"><h5><span>Location for : </span><span id="mapName"></span></h5></div>
      </div>
    </div>
</div>